// extracted by mini-css-extract-plugin
module.exports = {"promotionTile":"PromotionsTile_promotionTile__5-grm","promotionButton":"PromotionsTile_promotionButton__fwDOK","promotionActive":"PromotionsTile_promotionActive__NukSx"};